// extracted by mini-css-extract-plugin
export var addToCartButton = "_ug-b";
export var arrowButtonContainer = "_ug-9";
export var arrowButtonIcon = "_ug-a";
export var carouselArrowButton = "_ug-6";
export var carouselElementContainer = "_ug-1";
export var left = "_ug-7";
export var productDisplayCarouselContainer = "_ug-0";
export var productTileContainer = "_ug-2";
export var productTileImage = "_ug-4";
export var productTileImageContainer = "_ug-3";
export var productTileTitle = "_ug-5";
export var right = "_ug-8";
export var sliderOverflow = "_ug-c";